import React, { useEffect, useRef, useState } from "react";
import {AnimatePresence, delay, motion, usePresence} from "framer-motion";
import ProgressiveBackgroundImg from "../ProgressiveBackgroundImg/ProgressiveBackgroundImg";
import { progress, mix, cubicBezier, linear } from "popmotion"
import { primaryInput } from "detect-it";
import { useLocation, useNavigate } from 'react-router-dom';
import './styles.css';
import { gridAuxVariants, gridCounterScalerVariants, gridHeroVariants } from "./variants";
import { transitionTotalTime } from "./variables";
import { gridTileScales } from "../../globals/variables";
import { HomeTsProjTotalTransLength } from "../HomepageOverlayTransition/transitionVariables";


const gridTopVariants = {
    initial: (initParams) => ({
        transform: `translate3d(-50%, calc(-100% - 60px), 0) scale(1)`
    }),
    animate: (animParams) => ({
        transform:  [
                        `translate3d(-50%, calc(-100% - 60px), 0) scale(1)`,
                        `translate3d(${animParams[6]["middle-x"]}, ${animParams[6]["middle-y"]}, 0) scale(1)`,
                        `translate3d(${animParams[6]["middle-x"]}, ${animParams[6]["middle-y"]}, 0) scale(1)`,
                            animParams[0] == 0 ?
                                `translate3d(${animParams[6].leftmost},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 1 ?
                                `translate3d(${animParams[6]["middle-x"]},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 2 ?
                                `translate3d(${animParams[6].rightmost},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 3 ?
                                `translate3d(${animParams[6].left},${animParams[6].upper},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 4 ?
                                `translate3d(${animParams[6].right},${animParams[6].upper},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 5 ? 
                                `translate3d(${animParams[6].leftMiddle},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 6 ?
                                `translate3d(${animParams[6]["middle-x"]},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 7 ?
                                `translate3d(${animParams[6].rightMiddle},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 8 ?
                                `translate3d(${animParams[6].left},${animParams[6].lower},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 9 ?
                                `translate3d(${animParams[6].right},${animParams[6].lower},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 10?
                                `translate3d(${animParams[6].leftmost},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 11 ?
                                `translate3d(${animParams[6]["middle-x"]},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            :
                                `translate3d(${animParams[6].rightmost},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                    ],
                    transition:{
                        transform: {
                            times: [0, 1/transitionTotalTime, animParams[2], 1],
                            ease: [[0.87, 0, 0.13, 1], "linear", [0.16, 1, 0.3, 1]],
                            duration: transitionTotalTime,
                            delay: 1 //+ 0.025 * animParams[0] <= 2 ? 0 : animParams[0] <= 4 ? 1 : animParams[0] <= 7 ? 2 : animParams[0] <= 9 ? 3 : animParams <= 12 ? 4 : 5,
                        }
                    }
    }),
    exit: (i) => ({
        zIndex: i[5] ? 10: 1,
        transform: i[5] && `translate3d(${i[6]["middle-x"]},${i[6]["middle-y"]},0) scale(${i[3][0]}, ${i[3][1]})`,
        opacity: i[5] ? 1 : 0,
        transition: {
            duration: i[5] ? 1.15 : 1,
            ease: i[5] ? [0.87, 0, 0.13, 1] : [0.16, 1, 0.3, 1],
            zIndex: {
                duration: 0,
                delay: 0.1
            }
        }
    })
}

const gridBottomVariants = {
    initial: (initParams) => ({
        transform: `translate3d(-50%, calc(-60px + 100dvh), 0) scale(1)`
    }),
    animate: (animParams) => ({
        transform:  [
                        `translate3d(-50%, calc(-60px + 100dvh), 0) scale(1)`,
                        `translate3d(-50%, ${animParams[6]["middle-y"]}, 0) scale(1)`,
                        `translate3d(-50%, ${animParams[6]["middle-y"]}, 0) scale(1)`,
                        animParams[0] == 0 ?
                            `translate3d(${animParams[6].leftmost},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 1 ?
                            `translate3d(${animParams[6]["middle-x"]},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 2 ?
                            `translate3d(${animParams[6].rightmost},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 3 ?
                            `translate3d(${animParams[6].left},${animParams[6].upper},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 4 ?
                            `translate3d(${animParams[6].right},${animParams[6].upper},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 5 ? 
                            `translate3d(${animParams[6].leftMiddle},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 6 ?
                            `translate3d(${animParams[6]["middle-x"]},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 7 ?
                            `translate3d(${animParams[6].rightMiddle},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 8 ?
                            `translate3d(${animParams[6].left},${animParams[6].lower},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 9 ?
                            `translate3d(${animParams[6].right},${animParams[6].lower},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 10?
                            `translate3d(${animParams[6].leftmost},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        : animParams[0] == 11 ?
                            `translate3d(${animParams[6]["middle-x"]},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                        :
                            `translate3d(${animParams[6].rightmost},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                    ],
        transition:{
            transform: {
                times: [0, 1/transitionTotalTime, animParams[2], 1],
                ease: [[0.87, 0, 0.13, 1], "linear", [0.16, 1, 0.3, 1]],
                duration: transitionTotalTime,
                delay: 1 //+ 0.025 * animParams[0] <= 2 ? 0 : animParams[0] <= 4 ? 1 : animParams[0] <= 7 ? 2 : animParams[0] <= 9 ? 3 : animParams <= 12 ? 4 : 5, 
            }
        }
    }),
    
    exit: (i) => ({
        zIndex: i[5] ? 10: 1,
        transform: i[5] &&`translate3d(${i[6]["middle-x"]},${i[6]["middle-y"]},0) scale(${i[3][0]}, ${i[3][1]})`,
        opacity: i[5] ? 1 :0,
        display: "none",
        transition: {
            duration: i[5] ? 1.15 : 1,
            ease: i[5] ? [0.87, 0, 0.13, 1] : [0.16, 1, 0.3, 1],
            zIndex: {
                duration: 0,
                delay: 0
            },
            display: {
                duration: HomeTsProjTotalTransLength
            }
        }
    }), AExit: (animParams) => ({
        transition: {
            delay: 3,
            duration: 0,
        }
    })
}

function getDelayTiming(idx){
    if(idx <= 2){
        return 1/transitionTotalTime
    } else if(idx <= 4){
        return 0.03 + 1/transitionTotalTime 
    } else if(idx <= 7){
        return 0.05 + 1/transitionTotalTime 
    } else if(idx <= 9){
        return 0.07 + 1/transitionTotalTime 
    } else{
        return 0.09 + 1/transitionTotalTime 
    }
}

const gridPlaceVariants = {
    initial: (initialParams) => ({
        transform: `translate3d(${initialParams[6]["middle-x"]}, calc(-60px + ${(2*initialParams[1])}0dvh), 0) scale(1)`,
    }),
    animate: (animParams) => ({ 
        transform:  [
            `translate3d(${animParams[6]["middle-x"]}, calc(-60px + ${(2*animParams[1])}0dvh), 0) scale(1)`,
                        `translate3d(${animParams[6]["middle-x"]}, ${animParams[6]["middle-y"]}, 0) scale(1)`,
                        `translate3d(${animParams[6]["middle-x"]}, ${animParams[6]["middle-y"]}, 0) scale(1)`,
                            animParams[0] == 0 ?
                                `translate3d(${animParams[6].leftmost},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 1 ?
                                `translate3d(${animParams[6]["middle-x"]},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 2 ?
                                `translate3d(${animParams[6].rightmost},${animParams[6].top},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 3 ?
                                `translate3d(${animParams[6].left},${animParams[6].upper},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 4 ?
                                `translate3d(${animParams[6].right},${animParams[6].upper},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 5 ? 
                                `translate3d(${animParams[6].leftMiddle},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 6 ?
                                `translate3d(${animParams[6]["middle-x"]},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 7 ?
                                `translate3d(${animParams[6].rightMiddle},${animParams[6]["middle-y"]},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 8 ?
                                `translate3d(${animParams[6].left},${animParams[6].lower},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 9 ?
                                `translate3d(${animParams[6].right},${animParams[6].lower},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 10?
                                `translate3d(${animParams[6].leftmost},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            : animParams[0] == 11 ?
                                `translate3d(${animParams[6]["middle-x"]},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                            :
                                `translate3d(${animParams[6].rightmost},${animParams[6].bottom},0) scale(${animParams[3][0]}, ${animParams[3][1]})`
                    ],
        transition:{
            transform: {
                times: [0, 1/transitionTotalTime, animParams[2], 1],
                ease: [[0.87, 0, 0.13, 1], "linear", [0.16, 1, 0.3, 1]],
                duration: transitionTotalTime,
                delay: 1 // + 0.025 * animParams[0] <= 2 ? 0 : animParams[0] <= 4 ? 1 : animParams[0] <= 7 ? 2 : animParams[0] <= 9 ? 3 : animParams <= 12 ? 4 : 5,
            }
        }

    }),
    exit: (i) => ({
        zIndex: i[5] ? 10: 1,
        transform: i[5] && [null, `translate3d(${i[6]["middle-x"]},${i[6]["middle-y"]},0) scale(${i[3][0]}, ${i[3][1]})`],
        opacity: i[5] ? 1 : 0,
        transition: {
            duration: i[5] ? 1.15 : 1,
            ease: i[5] ? [0.87, 0, 0.13, 1] : [0.16, 1, 0.3, 1],
            zIndex: {
                duration: 0,
                delay: 0
            }
        }
    }), AExit: (i) => ({
        transform: `translate3d(${i[6]["middle-x"]}, calc(-60px + ${(2*i[1])}0dvh), 0) scale(1)`,
        transition: {
            duration: 1.2 + i[1] * 0.05,
            ease: [0.85, 0, 0.15, 1]
        }
    })
}

const gridImgWrapperVariants = {
    initial: {
        // transform: 'scale(1)',
        opacity: 0
    },
    animate: {
        // transform: ['scale(1)', `scale(1)`],
        opacity: 1,
        transition: {
            opacity: {
                duration: 0.25
            }
        }
    },
    exit: {

    }
}

const GridLayout = ({projData, activeIndex, activeMetaInfo, setActiveMetaInfo, slidingWindowTuple, isColumnView, setTriggerHomepageToProjectTransition}) => {
    const navigate = useNavigate();
    const [isPresent, safeToRemove] = usePresence();
    const [adjustedActiveIdx, setAdjustedActiveIdx] = useState(activeIndex-2);
    const [currentlyHovered, setCurrentlyHovered] = useState(null);
    const [tileScaler, setTileScaler] = useState(gridTileScales);
    const [scaledTileSize, setScaledTileSize] = useState(null);
    const [transformMappings, setTransformMappings] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isArchiveExit, setIsArchiveExit] = useState(null);
    const [midpoint, setMidpoint] = useState(null);
    const filterEffectRefs = useRef([]);
    

    const [selected, setSelected] = useState(null);
    const gridTileRefs = useRef([]);
    const scalerRefs = useRef([]);
    const handleMouseEnter = (idx) => {
        for(let i=slidingWindowTuple[0]; i<=slidingWindowTuple[1]; i++){
            if(i !== idx){
                setTimeout(() => {
                    filterEffectRefs.current[i].classList.add("greyscale");
                }, 35*i)
            }
        }
        
        gridTileRefs.current[idx].classList.add('gi_hover');
        gridTileRefs.current[idx].classList.remove('gi_hover_rm');
        setCurrentlyHovered(idx);
    }

    const handleMouseLeave = (idx) => {
        try{
        for(let i=slidingWindowTuple[0]; i<=slidingWindowTuple[1]; i++){
            if(i !== idx){
                setTimeout(() => {
                    filterEffectRefs.current[i].classList.remove("greyscale");
                }, 35*i)
            }
        }
        }catch{}
        gridTileRefs.current[idx].classList.remove('gi_hover');
        gridTileRefs.current[idx].classList.add('gi_hover_rm');
        // gridTileRefs.current[idx].style.transform = "scale3d(1, 1, 1)"
        setCurrentlyHovered(null);

    }

    const handleEleClick = (idx) => {
        let titleTarg = projData[idx].title;
        gridTileRefs.current[idx].classList.add("no-transition");
        handleMouseLeave(idx);
        setSelected(idx);
        setTriggerHomepageToProjectTransition([idx, 1]);
        setTimeout(() => {
            navigate('/projects/'+titleTarg, {state:{isFromHome:true}})
        }, 1250)
    }

    useEffect(() => {
        setIsVisible(false);
    }, [isArchiveExit])

    useEffect(() => {
        if(!isPresent) safeToRemove();
        if(window.location.href.includes("archive")){
            setIsArchiveExit(true)
        } else{
            setIsArchiveExit(false);
            setIsVisible(false);
        }
    }, [isPresent])

    useEffect(() => {
        if(selected !== null) setIsVisible(false)
    }, [selected])

    useEffect(() => {
        setAdjustedActiveIdx(activeIndex-2);
        setIsVisible(!isColumnView)
        if(!isColumnView){
            setMidpoint((slidingWindowTuple[0] + slidingWindowTuple[1])/2)
        }
    }, [isColumnView])

    useEffect(() => {
        // Need to know incoming tile width and height
        let startTileHeight = window.innerHeight/5;
        let startTileWidth = 1.9 * startTileHeight;
        let scaledTileHeight = tileScaler[1] * startTileHeight;
        let scaledTileWidth = tileScaler[0] * startTileWidth;

        let smallScaleHeight = (startTileHeight - 20) * tileScaler[1];
        let postScaleWidth = scaledTileWidth * (tileScaler[1]/tileScaler[0])

        setScaledTileSize([scaledTileWidth, scaledTileHeight]);
        let tmpTransformMappings = {
            'top': `calc(-50% + 60px)`,
            'upper': `calc((${-60 + window.innerHeight/2}px - 50% - 50% + 60px) / 2)`,
            'middle-y': `calc(${-60 + window.innerHeight/2}px - 50%)`,
            'lower': `calc((${-60 + window.innerHeight/2}px - 50% + ${(-60 * 2) + window.innerHeight - scaledTileHeight}px) / 2)`,
            'bottom': `${(-60 * 2) + window.innerHeight - scaledTileHeight}px`,
            'leftmost': `calc(((${scaledTileWidth/2}px + 20px - 50vw - 50%) / 1))`,
            'left': `calc(((${scaledTileWidth/2}px + 25vw - 20px - 50vw - 50%) / 1))`,
            'middle-x': `-50%`,
            'right': `calc(50vw - 25vw - 50% - ${scaledTileWidth/2}px + 20px)`,
            'rightmost': `calc(50vw - 50% - ${scaledTileWidth/2}px - 20px)`,
            'leftMiddle': `calc(((${scaledTileWidth/2}px + 20px - 50vw - 25%) / 1))`,
            'rightMiddle': `calc(50vw - 75% - ${scaledTileWidth/2}px - 20px)`,
        };

        setTransformMappings(tmpTransformMappings)

    }, [])
    useEffect(() => {
    }, [adjustedActiveIdx,tileScaler,selected,transformMappings, isColumnView])

    return(
        <AnimatePresence mode="wait">
        { transformMappings !== null && isVisible &&
            <motion.div 
                key={"grid_wrapper_home"}
                className="home_grid_wrapper"
                style={{
                    pointerEvents: isColumnView ? "none" : "all"
                }}
                initial={{
                    opacity: 0
                }} animate = {{
                    opacity: 1,
                    transition: {
                        duration: 1,
                        ease: "easeIn"
                    }
                }}
            >
                <motion.div className="home_grid_title__wrapper">
                    <AnimatePresence mode="wait">
                        {
                            currentlyHovered !== null && 
                            <motion.span
                                className="grid_mode_hero"
                                key={"grid-hero-"+Math.random()}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                                variants={gridHeroVariants}
                            >
                                {projData[currentlyHovered].title}
                            </motion.span>
                        }
                    </AnimatePresence>
                </motion.div>
                <div className="home_grid_thumbs" key={"grid_wrapper_"+adjustedActiveIdx}>
                    {
                        projData.map((projItem, idx) => (
                            (idx < (adjustedActiveIdx - 2) && (idx >= slidingWindowTuple[0])) ?
                                <motion.div 
                                    className="grid_ele__wrapper"
                                    ref={el => gridTileRefs.current[idx] = el}   
                                    initial="initial"
                                    animate={"animate"}
                                    exit={isColumnView ? "AExit" : 
                                        selected !== null ? "exit" : "defaultExit"}
                                    variants={gridTopVariants}
                                    custom={[
                                        idx - slidingWindowTuple[0], 
                                        (adjustedActiveIdx-2)-idx, 
                                        getDelayTiming(idx - slidingWindowTuple[0]),
                                        tileScaler,
                                        selected,
                                        selected==idx,
                                        transformMappings, 
                                        isColumnView
                                    ]}
                                >
                                    <div 
                                        className="home_project_tile grid_ele"
                                    >
                                        <div className="grid-filter-effects" ref={el => filterEffectRefs.current[idx] = el}>
                                            <motion.div 
                                                className="grid_counter__scaler"
                                                initial="initial"
                                                animate="animate"
                                                exit={isColumnView ? "AExit" : 
                                                    selected !== null ? "exit" : "defaultExit"}
                                                variants={gridCounterScalerVariants}
                                                custom={[
                                                    tileScaler[1]/tileScaler[0], 
                                                    getDelayTiming(idx - slidingWindowTuple[0]), 
                                                    idx - (adjustedActiveIdx-2),
                                                    isArchiveExit,
                                                    idx == midpoint,
                                                    selected == idx
                                                ]}
                                            > 
                                                <div 
                                                    className="grid_item_content__wrapper"
                                                >
                                                    <ProgressiveBackgroundImg
                                                        key={"grid-it"+idx}
                                                        placeholderSrc={projItem.thumbnails.placeholder}
                                                        src={projItem.thumbnails.mobile}
                                                        idx={idx}
                                                        isFirefox={false} 
                                                    />
                                                    {
                                                        primaryInput=="mouse" &&
                                                        <motion.video
                                                            muted
                                                            autoPlay
                                                            loop
                                                            className="grid-ele__hover"
                                                            onMouseEnter={(e) => {
                                                                if(selected == null)handleMouseEnter(idx);
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if(selected == null)handleMouseLeave(idx);
                                                            }}
                                                            onClick={(e) => handleEleClick(idx)}
                                                            style={{
                                                                height: "100%",
                                                                width: "100%",
                                                                objectFit: "cover"
                                                            }}
                                                        >
                                                            <source src={projItem.gifStyling.backgroundImage} type="video/mp4"  media="(min-width: 601px)" />
                                                            <source src={projItem.gifStyling.mobileVideo} type="video/mp4"  media="(max-width: 601px)" />
                                                        </motion.video>
                                                    }
                                                </div>
                                            </motion.div>
                                        </div>
                                    </div>
                                </motion.div>
                            : (idx > (adjustedActiveIdx + 2) && (idx <= (slidingWindowTuple[1]))) ?
                                <motion.div 
                                    className={`grid_ele__wrapper checker ${idx} ${[idx - slidingWindowTuple[0],
                                        idx - (adjustedActiveIdx-2),
                                        activeIndex,
                                        adjustedActiveIdx
                                        ]}`}
                                    ref={el => gridTileRefs.current[idx] = el}
                                    initial="initial"
                                    animate={"animate"}
                                    exit={isColumnView ? "AExit" : 
                                        selected !== null ? "exit" : 
                                        "defaultExit"}
                                    variants={gridBottomVariants}
                                    custom={[
                                        idx - slidingWindowTuple[0],
                                        idx - (adjustedActiveIdx-2),
                                        getDelayTiming(idx - slidingWindowTuple[0]),
                                        tileScaler,
                                        selected,
                                        selected==idx,
                                        transformMappings
                                    ]}
                                >
                                    <div className="home_project_tile grid_ele" >
                                        <div className="grid-filter-effects" ref={el => filterEffectRefs.current[idx] = el}>
                                            <motion.div 
                                                className="grid_counter__scaler"
                                                initial="initial"
                                                animate="animate"
                                                exit={
                                                    isColumnView ? "AExit" : 
                                                        selected !== null ? "exit" :
                                                        "defaultExit"
                                                }
                                                variants={gridCounterScalerVariants}
                                                custom={[
                                                    tileScaler[1]/tileScaler[0], 
                                                    getDelayTiming(idx - slidingWindowTuple[0]), 
                                                    idx - (adjustedActiveIdx-2),
                                                    isArchiveExit,
                                                    idx == midpoint,
                                                    selected == idx
                                                    
                                                ]}    
                                            > 
                                                <div 
                                                    className="grid_item_content__wrapper"
                                                >
                                                    <ProgressiveBackgroundImg
                                                        key={"grid-itm"+idx}
                                                        placeholderSrc={projItem.thumbnails.placeholder}
                                                        src={projItem.thumbnails.mobile}
                                                        idx={idx}
                                                        isFirefox={false} 
                                                    />
                                                    {
                                                        primaryInput=="mouse" &&
                                                        <motion.video
                                                            muted
                                                            autoPlay
                                                            loop
                                                            className="grid-ele__hover"
                                                            onMouseEnter={(e) => {
                                                                if(selected == null)handleMouseEnter(idx);
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if(selected == null)handleMouseLeave(idx);
                                                            }}
                                                            onClick={(e) => handleEleClick(idx)}
                                                            style={{
                                                                height: "100%",
                                                                width: "100%",
                                                                objectFit: "cover"
                                                            }}
                                                        >
                                                            <source src={projItem.gifStyling.backgroundImage} type="video/mp4"  media="(min-width: 601px)"/>
                                                            <source src={projItem.gifStyling.mobileVideo} type="video/mp4"  media="(max-width: 600px)" />
                                                        </motion.video>
                                                    }
                                                </div>
                                            </motion.div>
                                                
                                        </div>
                                    </div>
                                </motion.div>
                            : (idx <= adjustedActiveIdx + 2) && (idx >= adjustedActiveIdx-2) ?
                                <motion.div 
                                    className="grid_ele__wrapper"
                                    ref={el => gridTileRefs.current[idx] = el}
                                    initial="initial"
                                    animate={"animate"}
                                    exit={isColumnView ? "AExit" : 
                                        selected !== null ? "exit" : "defaultExit"}
                                    variants={gridPlaceVariants}
                                    custom={[
                                        idx - slidingWindowTuple[0],
                                        idx - (adjustedActiveIdx-2),
                                        getDelayTiming(idx - slidingWindowTuple[0]),
                                        tileScaler,
                                        selected,
                                        selected == idx,
                                        transformMappings
                                    ]}
                                >
                                    <div className="home_project_tile grid_ele" >
                                        <div className="grid-filter-effects" ref={el => filterEffectRefs.current[idx] = el}>
                                            <motion.div 
                                                className={`grid_counter__scaler ${[tileScaler[1]/tileScaler[0], getDelayTiming(idx - slidingWindowTuple[0])]}`}
                                                initial="initial"
                                                animate="animate"
                                                exit={isColumnView ? "AInViewExit" 
                                                    : selected !== null ? "exit" : "defaultExit"
                                                }
                                                variants={gridCounterScalerVariants}
                                                custom={[
                                                    tileScaler[1]/tileScaler[0], 
                                                    getDelayTiming(idx - slidingWindowTuple[0]), 
                                                    idx - (adjustedActiveIdx-2),
                                                    isArchiveExit,
                                                    idx == midpoint,
                                                    selected == idx
                                                ]}    
                                            >
                                                <div 
                                                    className="grid_item_content__wrapper"
                                                >
                                                    <ProgressiveBackgroundImg
                                                        key={"grid-item"+idx}
                                                        placeholderSrc={projItem.thumbnails.placeholder}
                                                        src={projItem.thumbnails.mobile}
                                                        idx={idx}
                                                        isFirefox={false} 
                                                    />
                                                    {
                                                        primaryInput=="mouse" &&
                                                        <motion.video
                                                            muted
                                                            autoPlay
                                                            loop
                                                            className="grid-ele__hover"
                                                            onMouseEnter={(e) => {
                                                                if(selected == null)handleMouseEnter(idx);
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if(selected == null)handleMouseLeave(idx);
                                                            }}
                                                            onClick={(e) => handleEleClick(idx)}
                                                            style={{
                                                                height: "100%",
                                                                width: "100%",
                                                                objectFit: "cover"
                                                            }}
                                                        >
                                                            <source src={projItem.gifStyling.backgroundImage} type="video/mp4" media="(min-width: 601px)"/>
                                                            <source src={projItem.gifStyling.mobileVideo} type="video/mp4" media="(max-width: 600px)"/>
                                                        </motion.video>
                                                    }
                                                </div>
                                            </motion.div>
                                        </div>
                                    </div>
                                </motion.div>
                            :
                                null
                        ))
                    }
                </div>
                <div className="grid_aux__wrapper">
                    <motion.div className="grid_aux__content">
                        <AnimatePresence mode="wait">
                            {
                                currentlyHovered !== null &&
                                    <motion.div 
                                        key={"grid-artist-"+Math.random()}
                                        className="grid_artist__wrapper"
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"
                                        variants={gridAuxVariants}
                                        custom={0.1}
                                    >
                                        {projData[currentlyHovered].artist}
                                    </motion.div>
                            
                            }
                        </AnimatePresence>
                        
                        <AnimatePresence mode="wait">
                            {
                                currentlyHovered !== null &&
                                    <motion.div 
                                        key={"grid-artist-"+Math.random()}
                                        className="grid_date__wrapper"
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"
                                        variants={gridAuxVariants}
                                        custom={0.2}
                                    >
                                        {projData[currentlyHovered].meta.date}
                                    </motion.div>
                            
                            }
                        </AnimatePresence>
                    </motion.div>
                </div>
            </motion.div>
        }
        </AnimatePresence>
    )
}

export default GridLayout;